module.exports = __webpack_public_path__ + "img/dianzi.19006fed.png";